import LeanLawAuth from '@/services/LeanLawAuth';
import '@/services/companyContextModal';
import '@/services/appUpdateBanner';
import '@/utils/bulkInvoiceCreateBanner';
console.log(' _                  _                \n' + '| |   ___ __ _ _ _ | |   __ ___ __ __\n' + "| |__/ -_) _` | ' \\| |__/ _` \\ V  V /\n" + '|____\\___\\__,_|_||_|____\\__,_|\\_/\\_/ \n' + '        - Welcomes Developers!\n', '\n' + 'SECURITY NOTICE \n' + 'Found a security issue? We want to hear from you!\n' + '- Contact: security@myleanlaw.com\n' + '- Please test responsibly and with prior authorization. Unauthorized testing violates our Terms of Service.\n' + '\n' + 'Hiring? Check out leanlaw.co/careers');

// ---------- CSS
require('../css/bootstrap.min.css');
//require("../css/glyphicons.css");
require('../css/unify-style.css');
require('../css/headers/header1.css');
require('../css/themes/default.css');
require('../css/style.css');
require('../css/style.layout.css');
require('../css/style.bootstrap.css');
require('../css/style.theme.unify.css');
require('../css/style.messages.css');
require('../css/style.threads.css');
require('../css/style.timeplanner.css');
require('../css/style.reports.css');
require('../css/style.settings.css');
require('../css/style.timesheets.css');
require('../css/style.setup.css');
require('../css/animate.css');
require('../css/autocomplete.css');
require('../css/jquery.onoff.css');
require('../css/chosen-ll.css');
const tippy = require('tippy.js').default;
const autosize = require('autosize');

// Main hook for sass files
require('../sass/app.sass');
window.leanlaw = {};
angular.module('leanlaw.core', []).factory('leanLawAuth', [() => new LeanLawAuth()]).factory('leanLawAuthenticate', ['$http', '$q', 'leanLawAuth', ($http, $q, leanLawAuth) => {
  let authenticated;
  return {
    authenticate
  };
  function authenticate() {
    if (!authenticated) {
      authenticated = $http.get(`${leanLawAuth.domain}/health/auth`).then(({
        data,
        status
      }) => {
        if (status === -1) {
          throw Error(`Unable to contact leanlaw servers at ${leanLawAuth.domain} - probably misconfigured`);
        }
        if (!data || !data.pass || !data.detail.authenticated) {
          leanLawAuth.login();
          return $q.defer().promise;
        }
        return true;
      });
    }
    return authenticated;
  }
}]);
const app = angular.module('leanlaw', ['ui.router', 'leanlaw.core', 'ui.select', 'ngAnimate', 'localytics.directives', 'ui.bootstrap', 'ngCsv', 'ngSanitize', 'angularModalService', 'angularUtils.directives.dirPagination', 'angular-loading-bar', 'autocomplete', '$q-spread']);
app.factory('_', ['$window', $window => $window._]);
app.factory('tippy', [() => tippy]);
app.factory('autosize', [() => autosize]);
app.config(['$locationProvider', '$animateProvider', '$sceDelegateProvider', 'cfpLoadingBarProvider', 'paginationTemplateProvider', '$httpProvider', ($locationProvider, $animateProvider, $sceDelegateProvider, cfpLoadingBarProvider, paginationTemplateProvider, $httpProvider) => {
  // $compileProvider.aHrefSanitizationTrustedUrlList(/^\s*(https?|mailto|tel):/);
  $sceDelegateProvider.resourceUrlWhitelist(['self', 'https://*.myleanlaw.co/**', 'https://vault.netvoyage.com/**', 'https://*.blob.core.windows.net/**']);
  $locationProvider.hashPrefix('');
  $httpProvider.defaults.withCredentials = true;

  // Disable spinner on loading bar
  cfpLoadingBarProvider.includeSpinner = false;
  cfpLoadingBarProvider.latencyThreshold = 300;

  // Disable ng-animate wherever it breaks things
  // Add .ng-animate-disabled to any element that ng-animate interferes with
  $animateProvider.classNameFilter(/^(?:(?!ng-animate-disabled).)*$/);

  // Use modified template for all paginations
  paginationTemplateProvider.setString(require('./directives/views/tsPaginationTemplate.html'));
}]);
const requireAll = r => r.keys().forEach(r);

// Our javascript -- recursively include everything
require('./routes.js');
requireAll(require.context('./services', true, /^(?!.*\.spec\.js$).*\.js$/));
requireAll(require.context('./directives', true, /^(?!.*\.spec\.js$).*\.js$/));
requireAll(require.context('./filters', true, /^(?!.*\.spec\.js$).*\.js$/));
requireAll(require.context('./modules', true, /^(?!.*\.spec\.js$).*\.js$/));
requireAll(require.context('./components', true, /^(?!.*\.spec\.js$).*\.js$/));
app.value('api', 'myleanlaw.co');
app.value('version', '{{LLVERSION}}');
app.run(['version', version => {
  console.log(`Version: ${version === '{{LLVERSION}}' ? 'dev' : version}`);
}]);
app.value('printPreview', {
  preview: false
});